import React, { useLayoutEffect } from 'react';
import { apiHolder, apis } from 'api';
const performanceApi = apiHolder.api.requireLogicalApi(apis.performanceImpl);
const LayoutPerf = ({ activeKey, setClickTick, tickStart, children }) => {
    useLayoutEffect(() => {
        if (activeKey && tickStart) {
            console.timeEnd('sidebar click ' + activeKey);
            setClickTick();
            performanceApi.timeEnd({
                statKey: 'side_bar_click_time' + (process.env.BUILD_ISEDM ? '_inEdm' : ''),
                statSubKey: activeKey,
            });
        }
    }, [activeKey, tickStart]);
    return React.createElement(React.Fragment, null, children);
};
export default LayoutPerf;
